export const COPY_CAMPAIGN_REQUEST = `CAMPAIGN_INDEX_COPY_CAMPAIGN_REQUEST`;
export const COPY_CAMPAIGN_RESPONSE = `CAMPAIGN_INDEX_COPY_CAMPAIGN_RESPONSE`;

export const ARCHIVE_CAMPAIGNS_REQUEST = `CAMPAIGN_INDEX_ARCHIVE_CAMPAIGNS_REQUEST`;
export const ARCHIVE_CAMPAIGNS_RESPONSE = `CAMPAIGN_INDEX_ARCHIVE_CAMPAIGNS_RESPONSE`;

export const UNARCHIVE_CAMPAIGNS_REQUEST = `CAMPAIGN_INDEX_UNARCHIVE_CAMPAIGNS_REQUEST`;
export const UNARCHIVE_CAMPAIGNS_RESPONSE = `CAMPAIGN_INDEX_UNARCHIVE_CAMPAIGNS_RESPONSE`;

export const EXPORT_CAMPAIGN_TO_CSV_REQUEST = `EXPORT_CAMPAIGN_TO_CSV_REQUEST`;
export const EXPORT_CAMPAIGN_TO_CSV_RESPONSE = `EXPORT_CAMPAIGN_TO_CSV_RESPONSE`;

export const GET_CAMPAIGN_METRICS_REQUEST = `GET_CAMPAIGN_METRICS_REQUEST`;
export const GET_CAMPAIGN_METRICS_RESPONSE = `GET_CAMPAIGN_METRICS_RESPONSE`;
